const category = {
    mangro : "Mangroves",
    agro: "Agroforesterie",
    admin: "Administration",
}

export default category